import { render, staticRenderFns } from "./CustomerFindNetMatch.vue?vue&type=template&id=5080b8a2"
import script from "./CustomerFindNetMatch.vue?vue&type=script&lang=ts"
export * from "./CustomerFindNetMatch.vue?vue&type=script&lang=ts"
import style0 from "./CustomerFindNetMatch.vue?vue&type=style&index=0&id=5080b8a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports